/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const fieldTypes = {
  COUNTRY: "country",
  DATE_PICKER: "datePicker",
  FORMAT: "eventFormat",
  SELECT: "select",
  MULTI_SELECT: "multiSelect",
  PROVINCE: "province",
  REGION: "region",
  CL_REGION: "clRegion",
  INDUSTRY_FOCUS: "industryFocus",
  TECHNICAL_EXPERTISE: "technicalExpertise",
  TECHNOLOGY_AREA_GROUP: "technologyAreaGroup",
  TECHNOLOGY_AREA: "technologyArea",
  REVIEW_STATUS: "reviewStatuses",
  AWARD_PERIOD: "awardPeriod",
  NDA_STATUS: "ndaStatus",
  BENEFIT_NAME: "benefitName",
  EXPEDITED: "expedited",
  ACTIVITY_OR_EVENT_TYPE: "activityOrEventType",
  AVAILABLE_CPM_LIST: "availableCpmList",
  SKU: "sku",
};

export enum FilterValueFieldNames {
  PROGRAM_STATUS = "programStatus",
  TECHNOLOGY_AREA = "technologyArea",
  AWARD_PERIOD_START_DATE = "awardPeriodStartDate",
  AWARD_PERIOD_END_DATE = "awardPeriodEndDate",
  LAST_INVITED_START_DATE = "lastInvitedStartDate",
  LAST_INVITED_END_DATE = "lastInvitedEndDate",
  NDA_STATUS = "ndaStatus",
  COUNTRY = "country",
  STATE_PROVINCE = "stateOrProvince",
  GRANT_ANNUAL_EXCEPTION = "grantAnnualException",
  REGION = "clRegion",
  INDUSTRY_FOCUS = "industryFocus",
  TECHNICAL_EXPERTISE = "technicalExpertise",
  TECHNOLOGY_AREA_GROUP = "technologyAreaGroup",
  BENEFIT_NAME = "benefitName",
  EXPEDITED = "expedited",
  ACTIVITY_OR_EVENT = "activityOrEvent",
  ACTIVITY_OR_EVENT_TYPE = "activityOrEventType",
  OTHER_PROGRAM_MEMBERSHIP = "otherProgramMembership",
  ASSIGNED_TO = "assignedTo",
  GENDER = "gender",
  SCORE = "technologyAreaScore",
  TECHNOLOGY_AREA_STATUS = "technologyAreaStatus",
  TECHNOLOGY_AREA_STATUS_REASON = "technologyAreaStatusReason",
  FLAG_ROLE = "flagRole",
  FLAG_REASON = "flagReason",
  COHORT = "cohort",
  TECHNOLOGY_AREA_SCORE = "technologyAreaScore",
  REVIEW_STATUS = "reviewStatuses",
  AVAILABLE_CPM_LIST = "availableCpmList",
  OVDF_BLOCK = "ovdfBlock",
}
